<template>
  <v-flex
    xs2
    justify-space-around
    align-center
    class="settings"
  >
    <TableHeaderSettings />
    <BlackBtn
      big
      :disabled="!selectedNum"
      @click="printPreviewNavigation"
    >
      <v-icon
        left
      >
        mdi-printer
      </v-icon>
      印刷画面へ
    </BlackBtn>
  </v-flex>
</template>
<script>
import { mapGetters } from 'vuex'
import TableHeaderSettings from './TableHeaderSettings'
import { BlackBtn } from '@/components/ui'
export default {
  name: 'SettingsIcon',
  components: {
    TableHeaderSettings,
    BlackBtn
  },
  computed: {
    ...mapGetters('list', ['selectedNum'])
  },
  methods: {
    printPreviewNavigation () {
      this.$router.push({ name: '印刷プレビュー画面' })
    }
  }
}
</script>
<style lang="scss" scoped>
.settings {
  display: flex;
  width: 100%;
  position: absolute;
  right: 0;
  bottom: -10px;
  transform: translateY(100%);
  padding-left: 10px;
}
</style>
